import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../../apiCall';
import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';

import { UPDATE_ATTRIBUTE, UPDATE_ATTRIBUTE_SUCCESS, UPDATE_ATTRIBUTE_ERROR } from './../../../actionType';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* updateAttribute({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/attributes`,
      method: 'POST',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Attribute updated successfully!`);
      // cogoToast.success(response?.data?.message)
      yield put({ type: UPDATE_ATTRIBUTE_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({ type: UPDATE_ATTRIBUTE_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: UPDATE_ATTRIBUTE_ERROR, payload: error });
  }
}

export function* watchUpdateAttribute() {
  yield takeEvery(UPDATE_ATTRIBUTE, updateAttribute);
}

function* updateAttributeSaga() {
  yield all([fork(watchUpdateAttribute)]);
}

export default updateAttributeSaga;
